import React from "react";

import { useRouterSearchParams } from "@/hooks/router";
import ResetPasswordScreen from "@/screens/Authentication/ResetPasswordScreen";

export default function Main(): React.JSX.Element {
  const emailAddress = useRouterSearchParams("emailAddress");
  return <ResetPasswordScreen emailAddress={emailAddress} />;
}
